import { 
    FETCHING_EMAIL_TEMPLATES_REQUEST, FETCHING_EMAIL_TEMPLATES_SUCCEDDED, FETCHING_EMAIL_TEMPLATES_FAILED,
    INVALIDATE_EMAIL_TEMPLATES, SELECTION_EMAIL_TEMPLATE, INVALIDATE_SELECTION_EMAIL_TEMPLATE,
    CREATING_EMAIL_TEMPLATE_REQUEST, CREATING_EMAIL_TEMPLATE_SUCCEDDED, CREATING_EMAIL_TEMPLATE_FAILED,
    UPDATING_EMAIL_TEMPLATE_REQUEST, UPDATING_EMAIL_TEMPLATE_SUCCEDDED, UPDATING_EMAIL_TEMPLATE_FAILED,
    DELETING_EMAIL_TEMPLATE_REQUEST, DELETING_EMAIL_TEMPLATE_SUCCEDDED, DELETING_EMAIL_TEMPLATE_FAILED,
    FETCHING_EMAIL_TEMPLATE_REQUEST, FETCHING_EMAIL_TEMPLATE_SUCCEDDED, FETCHING_EMAIL_TEMPLATE_FAILED,
    FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST, FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED, FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED,
    INVALIDATE_DEFAULT_EMAIL_TEMPLATE
} from './actionTypes.jsx';


import axios from "axios";
import buildUrl from "build-url-ts";

const apiUrl = process.env.REACT_APP_API_URL;


const EMAIL_TEMPLATES_BASE_URL = `${apiUrl}/api/2.0/email-templates`;

export function fetchEmailTemplates(query, page) {
  return function (dispatch) {
    dispatch(fetchingEmailTemplatesRequest());

    const param = {
      query: query,
      page: page
    }
    return axios({
        method: 'GET',
        url: EMAIL_TEMPLATES_BASE_URL,
        params: param
    })
    .then(response =>
        dispatch(fetchingEmailTemplatesSuccedded(response.data))
    )
    .catch(error =>
        dispatch(fetchingEmailTemplatesFailed(error))
    )
  }
}

function fetchingEmailTemplatesRequest() {
  return {
    type: FETCHING_EMAIL_TEMPLATES_REQUEST,
    payload: {}
  };
}

function fetchingEmailTemplatesSuccedded(json) {
  return {
    type: FETCHING_EMAIL_TEMPLATES_SUCCEDDED,
    payload: json
  };
}

function fetchingEmailTemplatesFailed(error) {
  return {
    type: FETCHING_EMAIL_TEMPLATES_FAILED,
    payload: error
  };
}

export function invalidateEmailTemplates() {
  return {
    type: INVALIDATE_EMAIL_TEMPLATES,
    payload: {}
  }
}

export function fetchEmailTemplate(id) {
  return function (dispatch) {
    dispatch(fetchingEmailTemplateRequest(id));

    let url = buildUrl(EMAIL_TEMPLATES_BASE_URL, {
      path: `${id}`
    });

    return axios({
        method: 'GET',
        url: url,
    })
    .then(response =>
        dispatch(fetchingEmailTemplateSuccedded(id, response.data))
    )
    .catch(error =>
        dispatch(fetchingEmailTemplateFailed(id, error))
    )
  }
}

function fetchingEmailTemplateRequest(id) {
  return {
    type: FETCHING_EMAIL_TEMPLATE_REQUEST,
    payload: id
  };
}

function fetchingEmailTemplateSuccedded(id, json) {
  return {
    type: FETCHING_EMAIL_TEMPLATE_SUCCEDDED,
    payload: {
      id: id,
      template: json
    }
  };
}

function fetchingEmailTemplateFailed(id, error) {
  return {
    type: FETCHING_EMAIL_TEMPLATE_FAILED,
    payload: {
      error: error,
      id: id
    }
  };
}

export function createEmailTemplate(emailTemplate) {
  return function (dispatch) {
    dispatch(creatingEmailTemplateRequest());
    return axios({
        method: 'POST',
        url: EMAIL_TEMPLATES_BASE_URL,
        data: emailTemplate
    })
    .then(response =>
        dispatch(creatingEmailTemplateSuccedded(response.data))
    )
    .catch(error =>
        dispatch(creatingEmailTemplateFailed(error))
    )
  }
}

function creatingEmailTemplateRequest() {
  return {
    type: CREATING_EMAIL_TEMPLATE_REQUEST,
    payload: {}
  };
}

function creatingEmailTemplateSuccedded(json) {
  return {
    type: CREATING_EMAIL_TEMPLATE_SUCCEDDED,
    payload: json
  };
}

function creatingEmailTemplateFailed(error) {
  return {
    type: CREATING_EMAIL_TEMPLATE_FAILED,
    payload: error
  };
}

export function updateEmailTemplate(id, emailTemplate) {
  return function (dispatch) {
    dispatch(updatingEmailTemplateRequest(id));

    let url = buildUrl(EMAIL_TEMPLATES_BASE_URL, {
      path: id
    });
    return axios({
        method: 'PUT',
        url: url,
        data: emailTemplate
    })
    .then(response =>
        dispatch(updatingEmailTemplateSuccedded(id, response.data))
    )
    .catch(error =>
        dispatch(updatingEmailTemplateFailed(id, error))
    )
  }
}

function updatingEmailTemplateRequest(id) {
  return {
    type: UPDATING_EMAIL_TEMPLATE_REQUEST,
    payload: id
  };
}

function updatingEmailTemplateSuccedded(id, json) {
  return {
    type: UPDATING_EMAIL_TEMPLATE_SUCCEDDED,
    payload: {
      id: id,
      template: json
    }
  };
}

function updatingEmailTemplateFailed(id, error) {
  return {
    type: UPDATING_EMAIL_TEMPLATE_FAILED,
    payload: {
      id: id,
      error: error
    }
  };
}

export function deleteEmailTemplate(id) {
  return function (dispatch) {
    dispatch(deletingEmailTemplateRequest(id));

    let url = buildUrl(EMAIL_TEMPLATES_BASE_URL, {
      path: `${id}`
    });

    return axios({
        method: 'DELETE',
        url: url
    })
    .then(response =>
        dispatch(deletingEmailTemplateSuccedded(response.data, id))
    )
    .catch(error =>
        dispatch(deletingEmailTemplateFailed(error, id))
    )
  }
}

function deletingEmailTemplateRequest(id) {
  return {
    type: DELETING_EMAIL_TEMPLATE_REQUEST,
    payload: id
  };
}

function deletingEmailTemplateSuccedded(json, id) {
  return {
    type: DELETING_EMAIL_TEMPLATE_SUCCEDDED,
    payload: {
     result : json,
     id: id
    }
  };
}

function deletingEmailTemplateFailed(error, id) {
  return {
    type: DELETING_EMAIL_TEMPLATE_FAILED,
    payload: {
      error : error,
      id: id
    }
  };
}

export function fetchDefaultEmailTemplate() {
  return function (dispatch) {
    dispatch(fetchingDefaultEmailTemplateRequest());

    let url = buildUrl(EMAIL_TEMPLATES_BASE_URL, {
      path: `default`
    });

    return axios({
        method: 'GET',
        url: url,
    })
    .then(response =>
        dispatch(fetchingDefaultEmailTemplateSuccedded(response.data))
    )
    .catch(error =>
        dispatch(fetchingDefaultEmailTemplateFailed(error))
    )
  }
}

function fetchingDefaultEmailTemplateRequest() {
  return {
    type: FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST,
    payload: {}
  };
}

function fetchingDefaultEmailTemplateSuccedded(json) {
  return {
    type: FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED,
    payload: json
  };
}

function fetchingDefaultEmailTemplateFailed(error) {
  return {
    type: FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED,
    payload: error
  };
}

/*
* select emailTemplate
*/
export function selectTemplate(emailTemplate){
  return {
    type: SELECTION_EMAIL_TEMPLATE,
    payload: emailTemplate
  }
}

export function invalidateSelectionEmailTemplate(){
  return {
    type: INVALIDATE_SELECTION_EMAIL_TEMPLATE,
    payload: {}
  }
}

export function invalidateDefaultEmailTemplate(){
  return {
    type: INVALIDATE_DEFAULT_EMAIL_TEMPLATE,
    payload: {}
  }
}


